import { gql } from '@apollo/client';

export const COURSE_LEVELS = gql`
  query course_level {
    course_level {
      id
      name
    }
  }
`;
